require('./bootstrap');

import Vue from 'vue';
import axios from 'axios';
import Notifications from 'vue-notification';
import VuejsDialog from 'vuejs-dialog';
import VuejsDialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js';
import { Form, Errors } from './clases.js';

import 'vuejs-dialog/dist/vuejs-dialog.min.css';

window.Vue = Vue;
window.axios = require('axios');
window.Form = Form;
window.baseURL = document.head.querySelector('meta[name="base-url"]').content;
window.axios.defaults.baseURL = window.baseURL;
window.Event = new Vue();

Vue.use(Notifications);
Vue.use(VuejsDialog, {
    html: true,
    okText: 'Confirmar',
    cancelText: 'Cancelar',
});

// Componentes
Vue.component('eli-modal', require('./components/ModalComponent.vue').default);

// Formularios
Vue.component('eli-form-persona', require('./components/forms/PersonaComponent.vue').default);
Vue.component('eli-form-personal-administrativo', require('./components/forms/PersonalAdministrativoComponent.vue').default);
Vue.component('eli-form-profesor', require('./components/forms/ProfesorComponent.vue').default);
Vue.component('eli-form-profesor-jornada-parcial', require('./components/forms/ProfesorJornadaParcialComponent.vue').default);

// Inputs
Vue.component('eli-input-asignatura', require('./components/inputs/AsignaturaComponent.vue').default);
Vue.component('eli-input-file', require('./components/inputs/FileComponent.vue').default);
Vue.component('eli-input-list', require('./components/inputs/ListComponent.vue').default);
Vue.component('eli-input-notas', require('./components/inputs/NotasComponent.vue').default);
Vue.component('eli-input-programa-proyecto', require('./components/inputs/ProgramaProyectoComponent.vue').default);
Vue.component('eli-input-tipo-cargo-profesor', require('./components/inputs/TipoCargoProfesorComponent.vue').default);

window.NotificarError = (error) => {
    if(error.response)
        window.Event.$emit('notificacion', 'error', 'Se ha producido un error con el siguiente código: ' + error.response.status);
    else
        window.Event.$emit('notificacion', 'error', 'Se ha producido el siguiente error: ' + error.message);
    window.Event.$emit('notificacion', 'error', 'Intente nuevamente o comuníquese con el administrador por favor para resolver su problema');
};

const app = new Vue({
    el: '#app',
    created() {
        window.Event.$on('errores', this.Errores);
        window.Event.$on('notificacion', this.Notificacion);
    },
    methods: {
        Errores(error) {
            for(let e in error.response.data.errors){
                for(let msg in error.response.data.errors[e]){
                    window.Event.$emit('notificacion', 'error', error.response.data.errors[e][msg]);
                }
            }
        },
        Modal(id, url) {
            window.Event.$emit('modal', id, url);
        },
        Notificacion(type, msg) {
            window.Vue.notify({
                duration: 7000,
                group: 'notificaciones',
                type: type,
                text: msg
            });
        },
    }
});

(function() {
    // Obtenemos elementos obligatorios
    var required = document.querySelectorAll(".form-control[required]");
    required.forEach(field => {
        field.parentElement.classList.add("form-group-required");
    });
})();

$(document).on("keypress", 'form', function (e) {
    var code = e.keyCode || e.which;
    if (code == 13) {
        e.preventDefault();
        return false;
    }
});